import React from "react";

import { View, Animated, RefreshControl } from "react-native";
import Loading from "component/section/Loading";

import { InfiniteData } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { colors, sizes } from "asset/constant";
import { useFlag } from "hook";
import { css } from "style";
import { mq } from "utils";

interface InfinityListPropsT {
  responseData?: InfiniteData<AxiosResponse<any, any>>;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  fetchNextPage?: () => void;
  renderItemList: (items: []) => JSX.Element | JSX.Element[];
  paddingBottom?: number;
  onRefresh?: () => Promise<any>;
}

export default function InfinityList(props: InfinityListPropsT) {
  const {
    onRefresh,
    responseData,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    renderItemList,
    paddingBottom,
  } = props;

  const { flg: refresh, on: startRefresh, off: stopRefresh } = useFlag();

  const _onRefresh = () => {
    startRefresh();
    onRefresh && onRefresh().then(stopRefresh);
  };

  return (
    <Animated.FlatList
      refreshControl={
        <RefreshControl
          colors={[colors.theme]}
          refreshing={refresh}
          onRefresh={_onRefresh}
        />
      }
      keyboardShouldPersistTaps="handled"
      initialNumToRender={5}
      removeClippedSubviews={true}
      contentContainerStyle={{
        paddingTop: sizes.space * 0.7,
        ...(paddingBottom && { paddingBottom }),
        ...css.growContainer,
      }}
      showsVerticalScrollIndicator={false}
      data={responseData?.pages?.length ? responseData?.pages : null}
      renderItem={({ item }) => <>{renderItemList(item.data.data)}</>}
      keyExtractor={(_, key) => String(key)}
      onEndReached={() => {
        hasNextPage && fetchNextPage && fetchNextPage();
      }}
      onEndReachedThreshold={0.1}
      ListFooterComponent={
        isFetchingNextPage ? (
          <View style={{ marginVertical: mq(20) }}>
            <Loading />
          </View>
        ) : (
          <></>
        )
      }
    />
  );
}
